import { createGlobalStyle, css } from 'styled-components'
import reset from 'styled-reset'

const Colors = css`
  :root {
    --brand-90: #00427e;
    --brand-70: #005cb1;
    --brand-50: #0083fc;
    --brand-40: #99cdfe;
    --brand-20: #cce6fe;
    --brand-10: #e5f2ff;
    --brand-5: #f2f9ff;

    --white: #ffffff;
    --black-100: #000000;
    --black-90: #1a1a1a;
    --black-80: #333333;
    --black-70: #4d4d4d;
    --black-60: #666666;
    --black-50: #808080;
    --black-40: #999999;
    --black-30: #b3b3b3;
    --black-20: #cccccc;
    --black-10: #e6e6e6;
    --black-8: #ebebeb;
    --black-6: #f0f0f0;
    --black-4: #f5f5f5;
    --black-2: #fafafa;

    --red-50: #f2373e;
    --red-30: #f67378;
    --red-20: #fcd7d8;
    --red-10: #feebeb;
    --red-5: #fef5f5;
  }
`
export const GlobalStyles = createGlobalStyle`
    ${Colors}
    ${reset}
    * {
        margin: 0;
        padding: 0;
        font: inherit;
        box-sizing: border-box;
        color: inherit;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }

    &.swiper-pagination {
        display: none
    }

    *,
    :after,
    :before {
        box-sizing: border-box;
    }

    /* Chrome, Safari, Edge, Opera */
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    /* Firefox  */
    input[type='number'] {
        -moz-appearance: textfield;
    }

    :root {
        -webkit-tap-highlight-color: transparent;
        -webkit-text-size-adjust: 100%;
        text-size-adjust: 100%;
        cursor: default;
        line-height: 1.4;
        overflow-wrap: break-word;
        word-break: break-word;
        color-scheme: light only;
        background-color: var(--black-2);
    }

    html,
    body {
        overflow: auto;
        box-sizing: border-box;


    }

    img,
    picture,
    video,
    canvas,
    svg {
        display: block;
        image-rendering: -webkit-optimize-contrast;
        transform: translateZ(0);
        backface-visibility: hidden;

    }

    button {
        background: none;
        border: 0;
        cursor: pointer;
    }

    :where(a) {
        text-decoration: none;
    }

    table {
        border-collapse: collapse;
        border-spacing: 0;
    }

    ul,
    ol {
        list-style: none;
        padding: 0;
        margin: 0;
    }

    :where(button, input, select, textarea) {
        border-radius: 0;
        border: none;
        width: 100%;
        background: 0 0;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        outline: 0;
        text-decoration: none;
        cursor: pointer;
        -webkit-text-size-adjust: none;
    }

    textarea {
        resize: none;
    }


    //Scrollbar Custom
    ::-webkit-scrollbar {
        width: 6px;
    }

    ::-webkit-scrollbar-track {
        background-color: transparent;
    }

    ::-webkit-scrollbar-thumb {
        background-color: var(--black-20);
        border-radius: 20px;
        box-sizing: border-box;
    }

`
